import { BaseEntity } from '../base-entity';
import { Dataset } from './dataset';
import { PbiOrganisationWorkspace } from './pbi-organisation-workspace';
import { PbiReport } from './pbi-report';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
/// </code-import>

export interface PbiDataset {
  id: string;
  createdDate: Date;
  datasetId: string;
  isDeleted: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  name: string;
  pbiWorkspaceId: string;
  periodEnd: Date;
  periodStart: Date;
  tenantKey: string;
  dataset: Dataset;
  pbiReports: PbiReport[];
  pbiWorkspace: PbiOrganisationWorkspace;
}

/// <module-code> Place module level code between <module-code> tags
export interface AskAgoraDDChatDataset {
  name: string;
  dataset_OrganisationWorkspace_TemplateWorkspace_Name: string;
  dataset_Category: string;
}
const typeFuncs = BaseEntity.makeStaticTypeFunctions<PbiDataset>(EntityName.PbiDataset);
/// </module-code>

export class PbiDataset extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static readonly propName = typeFuncs.propName;

  get organisationWorkspaceId(): string {
    if (!this.dataset) throw new Error('PbiDataset.dataset navigation property is not loaded');
    return this.dataset.organisationWorkspaceId;
  }
  /// </code>
  // Generated code. Do not place code below this line.
}
